import { AfterViewInit, Component, HostListener, ViewChild } from '@angular/core';
import { MapOptionsModel, MarkerLayerModel, PointModel } from 'src/app/fleet-tracker/model/models';
import { Activation } from '../services/device-geofence.service';
import { GeofencePrivacyLayerService } from '../services/geofence-privacy-layer.service';

@Component({
    selector: 'app-map',
    templateUrl: './map.component.html',
    styleUrls: ['./map.component.scss'],
})
export class MapComponent implements AfterViewInit {
    constructor(private _geofencePrivacyLayerService: GeofencePrivacyLayerService) { }

    @ViewChild('map') fleetTrackerComponent: any;

    center: PointModel = { lat: 39.7, lng: -89.0 };
    radius = 10 * 1000; // meters
    geofenceActivations: MarkerLayerModel<Activation>;
    geofence: any;
    mapEvent: google.maps.Map;
    bounds: PointModel[];
    mapClickEvent: boolean;

    styles = { 'border-radius': '5px' };
    drawerWidth: string = 335 + 'px';

    //
    // Demo options:
    //
    // All settings are optional (defaults described here for reference)
    //
    options: MapOptionsModel = {
        pan: true,          // default true -- can pan
        zoom: true,         // default true -- can zoom
        scrollable: true,   // default true -- can scroll the mouse
        draggable: true,    // default true -- can drag the map
        zoomLevel: 12,      // default 12
        lytxTheme: true,
        streetView: true,   // default false -- do not show control
        fullScreen: true,   // default false -- do not show control
        mapType: true,      // default false -- do not show control
        gestureHandling: 'cooperative',
        minZoomLevel: 2     // default 0
    };

    @HostListener('window:resize', ['$event'])
    getScreenSize(event?) {
        this.resetBounds();
    }

    onMarkerClick(marker: google.maps.Marker) { this.markerClick(marker); }
    onHistoryMarkerClick(marker: google.maps.Marker) { console.log(marker); }
    onBorderClick(border: google.maps.Polyline) { this.borderClick('Click', border); }
    onMapZoom(zoom: number) { this.mapZoom(zoom); }
    onMapClick(coords: google.maps.LatLng) { this.mapClick(coords); }
    onMapReady(map: google.maps.Map) {
        this.mapEvent = map;
    }

    async ngAfterViewInit(): Promise<any> {
        this.geofenceActivations = await this._geofencePrivacyLayerService.getGeofenceActivations();
    }

    async filterResults(value: string) {
        this.geofenceActivations = await this._geofencePrivacyLayerService.getGeofenceActivations(value);
    }

    selectItem(value: any) {
        this.fleetTrackerComponent.setPosition({lat: value.lat, lng: value.lng})
    }

    async markerClick(marker: google.maps.Marker) {
        var activation: Activation = marker.get('attachment').payload;
        this.geofence = await this._geofencePrivacyLayerService.getGeofence(activation);
    }

    private borderClick(event: string, border: google.maps.Polyline) {
        if (event === 'Click') {
            const attachment = border.get('attachment');
        }
    }

    private mapClick(coords) {
        this.geofence = null;
        this.mapEvent.addListener('click', (event) => {
            this.handleMapClick(event.latLng.lat(), event.latLng.lng());
        });
    }

    private handleMapClick(lat: number, lng: number): void {
        this.mapClickEvent = true;
        this.geofence = null;
    }

    private mapZoom(zoom) {
        console.log(zoom)
    }

    resetBounds() {
        this.fleetTrackerComponent.setPosition(this.bounds);
    }
}